import EnrollmentFlow from 'src/components/studentPages/EnrollmentFlow/EnrollmentFlow';

export default function EnrollmentFlowPage() {
  return <EnrollmentFlow />;
}
